// extracted by mini-css-extract-plugin
export default {"authLayout":"AuthSidebar_authLayout__hPBWb","authSidebarLeft":"AuthSidebar_authSidebarLeft__plxQI","circles":"AuthSidebar_circles__utBcn"};